import React, { Component } from 'react';
import styled from '@emotion/styled';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ErrorMessage, SuccessMessage } from '../SiteTakeovers/Alerts';
import colors from '../../../styling/colors';
import {
  openSignUpModal,
  openForgotPasswordModal,
} from '../../../redux/modals';
import { login } from '../../../redux/account';
import { AccountContainer } from './ModalContainers/ModalContainers';
import TextButton from '../Buttons/TextButton';
import ButtonWithUnderline from '../Buttons/ButtonWithUnderline';
import SocialButtons from './AuthModalComponents/SocialButtons';
import { StyledForm, Submit } from './AuthModalComponents/Form';
import {
  AuthEmailInput,
  AuthPasswordInput,
  Main,
  Container,
  Section,
  StyledDivider,
} from './AuthModalComponents/Layout';

const ForgotPasswordButton = styled(TextButton)`
  color: ${colors('gatsby')};
  cursor: pointer;
  font-size: 0.75rem;
  margin-left: auto;
  display: flex;
  text-decoration: none;
`;

export class LoginModal extends Component {
  static propTypes = {
    accountLoading: PropTypes.bool,
    errorMessage: PropTypes.string,
    login: PropTypes.func.isRequired,
    openSignUpModal: PropTypes.func.isRequired,
    openForgotPasswordModal: PropTypes.func.isRequired,
    redirectUrl: PropTypes.string,
  };

  static defaultProps = {
    accountLoading: false,
  };

  state = {
    email: '',
    password: '',
  };

  createHandleChange = prop => e => {
    const value = e.target.value;

    return this.setState({ [prop]: value });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { email, password } = this.state;

    this.props.login({ email, password });
  };

  render() {
    const {
      accountLoading,
      errorMessage,
      errorType,
      openSignUpModal,
      openForgotPasswordModal,
      successMessage,
      isMobile,
      redirectUrl,
    } = this.props;

    return (
      <AccountContainer isMobile={isMobile}>
        <Main>
          <Container>
            <Section>
              <SocialButtons redirectUrl={redirectUrl} type="login">
                Log in
              </SocialButtons>
              <StyledDivider>log in with email</StyledDivider>
              <StyledForm onSubmit={this.handleSubmit}>
                {errorMessage.length ? (
                  <ErrorMessage>{errorMessage}</ErrorMessage>
                ) : null}
                {successMessage.length ? (
                  <SuccessMessage>{successMessage}</SuccessMessage>
                ) : null}
                <AuthEmailInput
                  error={
                    errorMessage.length &&
                    (errorType === 'email' || errorType.length === 0)
                  }
                  onChange={this.createHandleChange('email')}
                  placeholder="Enter your email"
                  type="email"
                  value={this.state.email}
                />
                <AuthPasswordInput
                  error={
                    !!(
                      errorMessage.length &&
                      (errorType === 'password' || errorType.length === 0)
                    )
                  }
                  onChange={this.createHandleChange('password')}
                  placeholder="Enter your password"
                  type="password"
                  value={this.state.password}
                />
                <Submit disabled={accountLoading} type="submit">
                  Log In
                </Submit>
              </StyledForm>
              <div>
                <ForgotPasswordButton onClick={openForgotPasswordModal}>
                  Forgot Password?
                </ForgotPasswordButton>
                <ButtonWithUnderline onClick={openSignUpModal}>
                  Don’t have an account? <span>Sign up.</span>
                </ButtonWithUnderline>
              </div>
            </Section>
          </Container>
        </Main>
      </AccountContainer>
    );
  }
}

const mapStateToProps = ({
  account: { loading, errorMessage, errorType, successMessage },
  env: { isMobile },
  modals: { redirectUrl },
}) => ({
  accountLoading: loading,
  errorMessage,
  errorType,
  successMessage,
  isMobile,
  redirectUrl,
});

const mapDispatchToProps = {
  login,
  openSignUpModal,
  openForgotPasswordModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginModal);
